import * as d3 from 'd3'
import type { Color } from 'd3-color'

export type TextColorOnBackground = '#000' | '#fff'

export type BackgroundColorInput =
    | string
    | Color
    | { r: number; g: number; b: number }
    | null
    | undefined

/**
 * Returns contrasting text color (#000 or #fff) for a background color.
 */
export default function setTextColorWithBackground(
    input: BackgroundColorInput
): TextColorOnBackground {
    if (input == null) return '#000'

    let parsed: d3.RGBColor | d3.HSLColor | null
    if (typeof input === 'string') {
        parsed = d3.color(input)
    } else if ('r' in input && 'g' in input && 'b' in input) {
        parsed = d3.rgb(input.r, input.g, input.b)
    } else {
        parsed = d3.rgb(input as d3.RGBColor)
    }

    if (!parsed) return '#000'

    const { r, g, b } = d3.rgb(parsed)
    const luminance = Math.round((r * 299 + g * 587 + b * 114) / 1000)
    return luminance > 125 ? '#000' : '#fff'
}
